export const MAX_SLIDES_NUMBER = 20;
export const COMPANY_ID_ACTIVE = 6;
